/** "Job title · Company" — whichever halves are present, or '' when neither
 *  is. Callers that want a fallback apply it with `||`. */
export function formatPersonRole(
  jobTitle: string | null | undefined,
  company: string | null | undefined,
): string {
  const t = jobTitle?.trim() ?? '';
  const c = company?.trim() ?? '';
  if (t && c) return `${t} · ${c}`;
  return t || c;
}
